/**
 * TanStack Query hooks for `fraud-blacklist-synchronization-across-vendors`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fraudBlacklistSynchronizationAcrossVendorsQueryKeys,
	type CreateFraudBlacklistSynchronizationAcrossVendorsBody,
	type ListFraudBlacklistSynchronizationAcrossVendorsResponse,
	type FraudBlacklistSynchronizationAcrossVendorsRow,
} from "./api";

export function useFraudBlacklistSynchronizationAcrossVendorsList(): UseQueryResult<ListFraudBlacklistSynchronizationAcrossVendorsResponse, Error> {
	return useQuery({
		queryKey: fraudBlacklistSynchronizationAcrossVendorsQueryKeys.list(),
		queryFn: list,
	});
}

export function useFraudBlacklistSynchronizationAcrossVendorsCreate(): UseMutationResult<FraudBlacklistSynchronizationAcrossVendorsRow, Error, CreateFraudBlacklistSynchronizationAcrossVendorsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudBlacklistSynchronizationAcrossVendorsQueryKeys.all });
		},
	});
}

export function useFraudBlacklistSynchronizationAcrossVendorsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudBlacklistSynchronizationAcrossVendorsQueryKeys.all });
		},
	});
}
